export class CaliberMessage {
  name: string
  boreDiameter: number

  constructor(name: string, boreDiameter: number) {
    this.name = name
    this.boreDiameter = boreDiameter
  }
}